import React, { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import BizinBackend from "../../../helpers/bizin_helper";
import useGetCsrfToken from "../../../Hooks/useGetCsrfToken";
import { DF_LO0009Context } from "../context";
import { Col, Row, Spinner, Modal, ModalBody } from "reactstrap";
import NotificationModal from "../../../components/Common/NotificationModal";
import CardFlow from "../../../components/Common/CardFlow";
import CardContext from "../../../components/Common/CardContext";
import CardContextExpansive from "../../../components/Common/CardContextExpansive";
import TableSimple from "../../../components/Dynamic/TableSimple";
import ValidationDivergencyAlert from "../../../components/Common/ValidationDivergencyAlert";


function GridBody() {
  const { access_token, userProfile, isModalPage } = useSelector((state) => ({
    access_token: state.login.user?.access_token,
    userProfile: state.login.profile,
    isModalPage: state.Layout.isModalPage,
  }));

  const csrfToken = useGetCsrfToken();
  const { parseParams } = useContext(DF_LO0009Context);
  const ID_Arquivo = parseParams.get("ID_Arquivo");

  const [flowData, setFlowData] = useState([]);
  const [contextData, setContextData] = useState([]);
  const [dataContextExpansive, setDataContextExpansive] = useState([]);
  const [tipoVeiculoOptions, setTipoVeiculoOptions] = useState([]);
  const [inputs, setInputs] = useState({
    ID_Tipo_Veiculo: null,
    Placa_Veiculo: "",
    Nome_Motorista: "",
    CPF_Motorista: "",
  });
  const [isSaving, setIsSaving] = useState(false);
  const [notif, setNotif] = useState({ isOpen: false, type: "success", message: "" });
  const [validationResult, setValidationResult] = useState(null);
  const [showConfirmSave, setShowConfirmSave] = useState(false);
  const [openTipoVeiculo, setOpenTipoVeiculo] = useState(false);

  useEffect(() => {
    if (!ID_Arquivo) return;

    const handleGetResumo = async () => {
      try {
        const resp = await BizinBackend.executeProcedure(
          {
            1: userProfile?.ID_Usuario,
            2: "pt-BR",
            3: ID_Arquivo,
          },
          "FRONT_Workspace_DF_LO0009_Documento_Transporte_Obter_Resumo",
          csrfToken,
          access_token,
        );

        const flowResult =
          resp?.data?.resultset_1 ||
          resp?.resultset_1 ||
          (Array.isArray(resp) ? resp : []);

        setFlowData(
          (Array.isArray(flowResult) ? flowResult : []).map((item) => ({
            name: item.Nome_Empresa,
            logo: item.Logo_Empresa,
          })),
        );

        const contextResult =
          resp?.data?.resultset_2 || resp?.resultset_2 || [];

        setContextData(
          (Array.isArray(contextResult) ? contextResult : []).map((row) => ({
            label: row.Coluna,
            value: row.Valor,
          })),
        );

        const dadosResult =
          resp?.data?.resultset_3 || resp?.resultset_3 || [];
        const dadosRow = Array.isArray(dadosResult) ? dadosResult[0] : dadosResult;
        if (dadosRow?.Dados) {
          try {
            const parsed = JSON.parse(dadosRow.Dados) || [];
            setDataContextExpansive(parsed);
          } catch (e) {
            console.log("erro ao parsear resultset_3 Dados", e);
          }
        }
      } catch (error) {
        console.log("erro ao carregar resumo Documento de Transporte", error);
      }
    };

    const handleGetDadosCompletos = async () => {
      try {
        const resp = await BizinBackend.executeProcedure(
          {
            1: userProfile?.ID_Usuario,
            2: 10,
            3: null,
            4: userProfile?.ID_Idioma ?? 1,
            5: ID_Arquivo,
            6: null,
            7: null,
            8: null,
          },
          "SRM_Get_Dados_Completos_CTe",
          csrfToken,
          access_token,
        );

        const cteRows = resp?.data?.resultset_1 || resp?.resultset_1 || [];
        const veiculosRows = resp?.data?.resultset_2 || resp?.resultset_2 || [];

        const row = Array.isArray(cteRows) ? cteRows[0] : cteRows;

        if (row) {
          setInputs({
            ID_Tipo_Veiculo: row.ID_Tipo_Veiculo || null,
            Placa_Veiculo: (row.Placa_Veiculo || "").trim(),
            Nome_Motorista: (row.Nome_Motorista || "").trim(),
            CPF_Motorista: row.CPF_Motorista
              ? String(row.CPF_Motorista).replace(/\D/g, "").replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4")
              : "",
          });
        }

        if (Array.isArray(veiculosRows) && veiculosRows.length) {
          const opts = veiculosRows.map((item) => ({
            value: item.ID_Tipo_Veiculo,
            label: item.Descricao_Veiculo,
          }));
          setTipoVeiculoOptions(opts);
        }
      } catch (error) {
        console.log("erro ao carregar dados completos Documento de Transporte", error);
      }
    };

    handleGetResumo();
    handleGetDadosCompletos();
  }, [ID_Arquivo, csrfToken, access_token, userProfile?.ID_Usuario, userProfile?.ID_Idioma]);

  const selectedTipoVeiculoLabel = tipoVeiculoOptions.find(o => o.value === inputs.ID_Tipo_Veiculo)?.label || "";

  const handleSimulate = async (onlyErrors = false) => {
    if (!inputs.ID_Tipo_Veiculo) return;
    try {
      setIsSaving(true);
      setValidationResult(null);

      const resp = await BizinBackend.executeProcedure(
        {
          1: ID_Arquivo,
          2: "S",
          3: inputs.ID_Tipo_Veiculo,
          4: userProfile?.ID_Usuario,
          5: onlyErrors ? "S" : null,
        },
        "FRONT_Workspace_DF_LO0009_Documento_Transporte_Validar",
        csrfToken,
        access_token,
      );

      const rows =
        resp?.data?.resultset_1 ||
        resp?.resultset_1 ||
        (Array.isArray(resp) ? resp : []);

      const totalizadores =
        resp?.data?.resultset_2 || resp?.resultset_2 || [];
      const totalItensDivergentes =
        totalizadores?.[0]?.Total_Itens_Divergentes || "";

      const hasError = rows.some((r) => r?.Tipo_Mensagem === "E");

      setValidationResult({
        rows,
        hasError,
        totalItensDivergentes,
        onlyErrors,
      });
    } catch (error) {
      console.log("erro ao validar Documento de Transporte", error);
      setNotif({
        isOpen: true,
        type: "error",
        message: "Erro ao validar o Documento de Transporte. Tente novamente.",
      });
    } finally {
      setIsSaving(false);
    }
  };

  const confirmSalvarAlteracoes = async () => {
    try {
      setShowConfirmSave(false);
      setIsSaving(true);

      await BizinBackend.executeProcedure(
        { 1: ID_Arquivo, 2: 'N' },
        "SRM_Valida_CT",
        csrfToken,
        access_token,
      );

      await BizinBackend.executeProcedure(
        {
          1: ID_Arquivo,
          2: userProfile?.ID_Usuario
        },
        "FRONT_Workspace_DF_LO0009_Documento_Transporte_Enviar",
        csrfToken,
        access_token,
      );

      setNotif({
        isOpen: true,
        type: "success",
        message: "Alterações salvas com sucesso!",
      });
    } catch (error) {
      console.log("erro ao salvar alterações Documento de Transporte", error);
      setNotif({
        isOpen: true,
        type: "error",
        message: "Erro ao salvar as alterações. Tente novamente.",
      });
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <>
      <Row className="my-3 d-flex align-items-center">
        <Col md={isModalPage ? 12 : 'auto'}>
          {flowData.length > 0 && (
            <div className="mb-3 d-flex">
              <CardFlow flowData={flowData} enableTooltip={false} />
            </div>
          )}
        </Col>

        <Col md={isModalPage ? 12 : ''}>
          {contextData.length > 0 && (
            <div className="mb-3">
              <CardContext data={contextData} enableTooltip={false} />
            </div>
          )}
        </Col>
      </Row>

      {dataContextExpansive?.length > 0 && (
        <div className="mb-4">
          <CardContextExpansive data={dataContextExpansive} />
        </div>
      )}

      <div className="card-context-dynamic-wrapper d-flex flex-column cb-variant-bordered mb-3">
        <div className="card-context-dynamic p-4">
          <label className="fw-semibold fs-6 text-color-azul1 mb-2">
            Selecione o veículo
          </label>

          <div className="position-relative" style={{ maxWidth: 320 }}>
            <div
              className="form-control d-flex justify-content-between align-items-center"
              style={{ cursor: "pointer" }}
              onClick={() => setOpenTipoVeiculo(!openTipoVeiculo)}
            >
              <span>{selectedTipoVeiculoLabel || "Selecionar"}</span>

              <i
                className={`fas ${
                  openTipoVeiculo ? "fa-chevron-up" : "fa-chevron-down"
                }`}
              />
            </div>

            {openTipoVeiculo && (
              <div
                className="shadow mt-1"
                style={{
                  position: "absolute",
                  left: 0,
                  width: "100%",
                  zIndex: 999,
                  maxHeight: "250px",
                  overflowY: "auto",
                  borderRadius: "6px",
                  boxSizing: "border-box",
                  backgroundColor: "#F5F5F5",
                }}
              >
                {tipoVeiculoOptions.map((item, index) => (
                  <div
                    key={index}
                    className={`reason-item ${
                      inputs.ID_Tipo_Veiculo === item.value ? "active" : ""
                    }`}
                    onClick={() => {
                      setInputs((s) => ({ ...s, ID_Tipo_Veiculo: item.value }));
                      setOpenTipoVeiculo(false);
                    }}
                  >
                    <span>{item.label}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>

      {validationResult && (
        <>
          {validationResult.totalItensDivergentes && (
            <ValidationDivergencyAlert
              onlyErrors={validationResult.onlyErrors}
              totalText={validationResult.totalItensDivergentes}
              onVerify={() => handleSimulate(true)}
              onShowAll={() => handleSimulate(false)}
            />
          )}
          <TableSimple
            dataKey={"ID_Resultado"}
            data={validationResult.rows}
            enableTotalRows
            rowClassName={(row) =>
              row?.Tipo_Mensagem === "E" ? "row-error-validacao" : ""
            }
            columnsList={[
              {
                field: "Icone_Flag",
                header: "",
                hasImage: true,
                width: "3.5%",
                align: "end",
              },
              {
                field: "Icone_Regra",
                header: "Regra",
                hasImage: true,
              },
              {
                field: "Mensagem",
                header: "Descrição",
                width: "91%",
              },
            ]}
          />
        </>
      )}

      <hr />
      <div className="d-flex gap-2 align-items-center justify-content-end mt-3">
        <button
          type="button"
          onClick={() => handleSimulate()}
          disabled={!inputs.ID_Tipo_Veiculo || isSaving}
          className="btn bg-primary-dark-inverse fw-bold px-4"
        >
          {isSaving ? <Spinner size="sm" /> : "Simular Validações"}
        </button>
        <button
          type="button"
          onClick={() => setShowConfirmSave(true)}
          disabled={!validationResult || validationResult.hasError || isSaving}
          className={`btn fw-bold px-4 ${
            validationResult && !validationResult.hasError
              ? "bg-primary-dark border border-primary-dark text-white"
              : "disabled bg-color-cinza2 text-color-cinza4 border border-color-cinza2"
          }`}
        >
          Salvar Alterações
        </button>
      </div>

      <NotificationModal
        isOpen={notif.isOpen}
        type={notif.type}
        message={notif.message}
        onClose={() => setNotif((s) => ({ ...s, isOpen: false }))}
      />

      <Modal
        className="modal-dinamic-table-simple"
        isOpen={showConfirmSave}
        centered
      >
        <div>
          <div className="modal-header d-flex align-items-center justify-content-between">
            <h5
              className="modal-title mt-0 font-size-24 font-w-600 text-color-azul1"
            >
              Validação Documento de Transporte
            </h5>
            <button
              type="button"
              onClick={() => setShowConfirmSave(false)}
              className="btn border-0 p-0"
              data-dismiss="modal"
              aria-label="Close"
              disabled={isSaving}
            >
              <i className="fas fa-times font-size-24 text-gray-secundary"></i>
            </button>
          </div>

          <ModalBody className="text-center p-4">
            <div className="icon-warning mb-4">
              <i className="fas fa-exclamation-triangle"></i>
            </div>

            <h5 className="modal-title-custom mb-4">
              Realmente deseja salvar
              <br />
              as alterações?
            </h5>

            <div className="d-flex justify-content-center gap-3">
              <button
                className="btn border-0 fw-bold px-4 btn-cancelar-co0005"
                onClick={() => setShowConfirmSave(false)}
                disabled={isSaving}
              >
                Cancelar
              </button>

              <button
                className="btn border-0 fw-bold px-4 btn-confirmar-co0005"
                onClick={confirmSalvarAlteracoes}
                disabled={isSaving}
              >
                {isSaving ? "Processando..." : "Confirmar"}
              </button>
            </div>
          </ModalBody>
        </div>
      </Modal>
    </>
  );
}

export default GridBody;
